import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { Link } from "react-router-dom";
import { currentDateAndTime, decodeData ,encodeData} from "../../Constants/constants";

class LetterHeadList extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      company_letter_head_id: 0,
      rows: [],
      keyword: "",
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      loadingSearch: false,
      decodedData: [],
      decodedDataId:'',

    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  getBack=()=>{
    window.history.back();
}
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetLetterHeads`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch: false });
        }
      })
      .catch((error) => {
        this.setState({ loadingList: false, loadingSearch: false });
      });
  };
  // handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState((prevState) => ({
  //     [name]: value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: "",
  //     },
  //   }));
  // };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    },
    () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };
  handleInputSearch = (e) => {
    this.setState({ loadingSearch: true }, () => {
      this.GetList();
    });
  };
  handleClearAll = () => {
    this.setState(
      {
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        keyword: "",
      },
      () => {
        this.GetList();
      }
    );
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          company_letter_head_id: id,
          date: currentDateAndTime(),
        };
        axios
          .post(`${apiURL}Masters/DeleteLetterHead`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${
                response.data.success === true ? "Success" : "Failed"
              }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
              timer: 1000,
              showConfirmButton: true,
              allowOutsideClick: false,
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1,
      },
      () => {
        this.GetList();
      }
    );
  };
  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Letter List`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header align-items-center d-flex">
                    <div className="card-title mb-0 flex-grow-1">

                      <div className="col-md-3">
                        <label htmlFor="keyword">Letter Head Name</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Name"
                          />

                          <button
                            className="btn btn-success"
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    { this.state.decodedData?.includes(2) && ( 
                    <div className="col-md-3">
                      <Link
                        className="btn btn-success mt-4"
                        to={"/LetterHead"}
                        style={{ float: "right" }}
                        type="button"
                      >
                        Add Letter Head
                      </Link>
                    </div>)}
                  </div>

                  <table className={`table table-bordered table-hover`}>
                    <thead className="table-light">
                      <tr>
                        <th style={{ width:"90%"}}>Letter Heads</th>
                        { (this.state.decodedData?.includes(4) || this.state.decodedData?.includes(3)) && (
                        <th className="text-center">Action</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.rows.map((row) => {
                        return (
                          <tr key={row.company_letter_head_id}>
                            <td>{row.company_letter_head_name}</td>
                            { (this.state.decodedData?.includes(4) || this.state.decodedData?.includes(3)) && (
                            <td className="d-flex justify-content-around">
                            { this.state.decodedData?.includes(3) && (  
                              <Link
                                to={`/LetterHead/${row.company_letter_head_id}?abs=${encodeData(this.state.decodedDataId)}`}
                                className="btn-icon btn btn-sm btn-outline-primary"
                              >
                                <i className="ri-edit-box-line"></i>
                              </Link>)}
                              { this.state.decodedData?.includes(4) && (  
                              <button
                                onClick={() =>
                                  this.handleDelete(row.company_letter_head_id)
                                }
                                className="btn-icon btn btn-sm btn-outline-danger"
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>)}
                            </td>)}
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot className="table-light">
                      <tr>
                        <th colSpan={7}>
                          <div className="d-flex justify-content-between">
                            <button
                              disabled={
                                this.state.prev === false &&
                                this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handlePrev()}
                              className={`btn btn-warning btn-label waves-effect waves-light`}
                            >
                              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                              Previous
                            </button>
                            <div
                              className="col-md-4"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {
                                <small>
                                  Total Records: {this.state.total_records} |
                                  Total Pages: {this.state.total_pages} |
                                  Current Page: {this.state.page}
                                </small>
                              }
                            </div>
                            <div className="col-md-2">
                              <select
                                className="form-select"
                                onChange={(e) => this.handleChange(e)}
                              >
                                {Array.from(
                                  { length: this.state.total_pages },
                                  (_, i) => (
                                    <option
                                      selected={this.state.page === i + 1}
                                      key={i}
                                      value={i + 1}
                                    >
                                      Page {i + 1}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="col-md-2">
                              <select
                                className="form-select"
                                onChange={this.handleLimitChange}
                                value={this.state.limit}
                              >
                              <option value={this.state.total_records}>All</option>
                                {limitOptions.map((option) => (
                                  <option key={option} value={option}>
                                    Limit {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              disabled={
                                this.state.next === false &&
                                this.state.loadingList === false
                                  ? true
                                  : false
                              }
                              type="button"
                              onClick={() => this.handleNext()}
                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                            >
                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                              Next
                            </button>
                          </div>
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LetterHeadList);
